import { Box, Button, CircularProgress, Divider, Grid, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import apiUrl from '../../Config';
import axios from 'axios';
import { toast } from 'react-toastify';

const AddEditCancellationPolicy = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const cancellation = location?.state?.cancellation || '';
    const [formData, setFormData] = useState({
        id: '',
        hoursFrom: '',
        hoursTo: '',
        refundPercentage: '',
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [validateErrors, setValidateErrors] = useState({})
    useEffect(() => {
        if (cancellation) {
            setFormData({
                id: cancellation?.id || '',
                hoursFrom: cancellation?.hoursFrom || '',
                hoursTo: cancellation?.hoursTo || '',
                refundPercentage: cancellation?.refundPercentage || '',
            });
        }
    }, [cancellation]);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setValidateErrors(prev => ({ ...prev, [name]: '' }));
        setError('');
    };
    const validateForm = () => {
        const errors = {};

        // if (!formData.hoursFrom?.trim()) {
        //     errors.hoursFrom = "Hours from  is required";
        // }

        // if (!formData.hoursTo?.trim()) {
        //     errors.hoursTo = "Hours to  is required";
        // }
        // if (!formData.refundPercentage?.trim()) {
        //     errors.refundPercentage = "Refund percentage  is required";
        // }

        if (!String(formData.hoursFrom).trim()) {
            errors.hoursFrom = "Hours from is required";
        }
        if (!String(formData.hoursTo).trim()) {
            errors.hoursTo = "Hours to is required";
        }
        if (!String(formData.refundPercentage).trim()) {
            errors.refundPercentage = "Refund percentage is required";
        }


        return errors;
    };
    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     const errors = validateForm();
    //     if (Object.keys(errors).length > 0) {
    //         setValidateErrors(errors);
    //         return;
    //     }

    //     setLoading(true);
    //     try {


    //         const isEditMode = !!formData.id;

    //         const response = isEditMode
    //             ? await axios.put(`${apiUrl}/banners/updatebanner/${formData.id}`, formData)
    //             : await axios.post(`${apiUrl}/cancellation/policies`, formData);

    //         if (response?.data?.status === true) {
    //             navigate(-1);
    //             toast.success(response?.data?.message);
    //         }
    //     } catch (error) {
    //         setError(error?.response?.data?.message || 'Something went wrong. Please try again later.');
    //     } finally {
    //         setLoading(false);
    //     }
    // };



    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setValidateErrors(errors);
            return;
        }
        setLoading(true);
        try {
            const isEditMode = !!formData.id;
            const postData = {
                ...formData,
                hoursFrom: Number(formData.hoursFrom),
                hoursTo: Number(formData.hoursTo),
                refundPercentage: Number(formData.refundPercentage),
            };
            const response = isEditMode
                ? await axios.put(`${apiUrl}/cancellation/policies/${formData.id}`, postData)
                : await axios.post(`${apiUrl}/cancellation/policies`, postData);
            if (response?.data?.status === true) {
                navigate(-1);
                toast.success(response?.data?.message);
            }
        } catch (error) {
            setError(error?.response?.data?.message || 'Something went wrong. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Box sx={{ p: { xs: 2, sm: 2 } }}>
                <Typography variant="h4" fontWeight={400} mb={1} >
                    {cancellation ? `Edit Cancellation` : 'Add Cancellation'}
                </Typography>
                <Divider sx={{ mb: 3 }} />
                <Box sx={{ maxWidth: 500, border: '1px solid lightgrey', borderRadius: 1, p: 2 }}>
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item size={{ xs: 12, sm: 12 }}>
                                <TextField
                                    label="Hours from"
                                    name="hoursFrom"
                                    fullWidth
                                    type='number'
                                    size="small"
                                    value={formData.hoursFrom}
                                    onChange={handleInputChange}
                                    error={!!validateErrors.hoursFrom}
                                    helperText={validateErrors.hoursFrom}
                                />
                            </Grid>

                            {/* Banner Description */}
                            <Grid item size={{ xs: 12, sm: 12 }}>
                                <TextField
                                    label="Hours To"
                                    name="hoursTo"
                                    fullWidth
                                    size="small"
                                    type='number'
                                    value={formData.hoursTo}
                                    onChange={handleInputChange}
                                    error={!!validateErrors.hoursTo}
                                    helperText={validateErrors.hoursTo}
                                />
                            </Grid>

                            {/* Banner Order */}
                            <Grid item size={{ xs: 12, sm: 12 }}>
                                <TextField
                                    label="Refund Percentage"
                                    name="refundPercentage"
                                    fullWidth
                                    type='number'
                                    size="small"
                                    value={formData.refundPercentage}
                                    onChange={handleInputChange}
                                    error={!!validateErrors.refundPercentage}
                                    helperText={validateErrors.refundPercentage}
                                />
                            </Grid>

                            {/* Error Message */}
                            {error && (
                                <Grid item size={12}>
                                    <Typography color="error">{error}</Typography>
                                </Grid>
                            )}

                            {/* Submit Button */}
                            <Grid item size={12}>
                                <Box display="flex" justifyContent="end" mt={2} gap={2}>
                                    <Button variant="outlined" color="primary" onClick={() => navigate(-1)}>
                                        Cancel
                                    </Button>
                                    <Button type="submit" variant="contained" disabled={loading}>
                                        {loading ? (
                                            <CircularProgress size={24} sx={{ color: '#fff' }} />
                                        ) : (
                                            cancellation ? 'Update' : 'Create'
                                        )}
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </Box>
            </Box>
        </>
    )
}

export default AddEditCancellationPolicy
